import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useContext, useState } from "react";
import { userJourneyContext } from "../../states/context/userJourneyContext";
import { getProgress } from "./mockUtils";
import greenCheck from "../../assets/images/greenCheck.svg";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import { trackUserJourney } from "../../services/api.service";

const ProgressBar = () => {
  const userContext = useContext(userJourneyContext);
  const classes = useStyles();
  const [progress, setProgress] = useState(0);
  const [steps, setSteps] = useState([
    { status: "current", step: "1", name: "Control Tower" },
    { status: "incomplete", step: "2", name: "Threats & Alerts" },
    { status: "incomplete", step: "3", name: "Order Timeline" },
    { status: "incomplete", step: "4", name: "Communications Hub" },
    { status: "incomplete", step: "5", name: "Add Shipping Information" },
    { status: "incomplete", step: "6", name: "Global Risks" },
  ]);
  const history = useHistory();
  const [show, setShow] = useState(false);

  React.useEffect(() => {
    setProgress(getProgress(userContext.userJourneyInfo));
    const newArr = [...steps];
    if (progress === 25) {
      newArr[0]["status"] = "completed";
      newArr[1]["status"] = "current";
      setSteps(newArr);
      return;
    }
    if (progress === 40) {
      newArr[1]["status"] = "completed";
      newArr[2]["status"] = "current";
      setSteps(newArr);
      return;
    }
    if (progress === 50) {
      newArr[2]["status"] = "completed";
      newArr[3]["status"] = "current";
      setSteps(newArr);
      return;
    }
    if (progress === 70) {
      newArr[3]["status"] = "completed";
      newArr[4]["status"] = "current";
      setSteps(newArr);
      return;
    }
    if (progress === 80) {
      newArr[4]["status"] = "completed";
      newArr[5]["status"] = "current";
      setSteps(newArr);
      return;
    }
    if (progress === 90) {
      newArr[5]["status"] = "completed";
      setSteps(newArr);
      return;
    }
  }, [userContext.userJourneyInfo.payload.steps, progress]);

  const handleClick = () => {
    (async () => {
      try {
        let payload = {
          name: userContext.userJourneyInfo.name,
          email: userContext.userJourneyInfo.email,
          action: userContext.userJourneyInfo.action,
          payload: {
            title: "Restart",
            steps: 0,
            last_step: userContext.userJourneyInfo.payload.title,
            role: "Merchandiser",
          },
        };
        await trackUserJourney(payload);
      } catch (e) {
        console.log(e);
      }
    })();
  };

  const handleShow = () => {
    setShow(!show);
  };

  return (
    <div style={{ backgroundColor: "#E5E5E5" }}>
      <Card elevation={1} className={classes.progressBarContainer}>
        <Box
          sx={{ display: "flex", alignItems: "center" }}
          style={{ padding: "16px", display: "block" }}
        >
          <div>
            <div className={classes.headerContainer}>
              <h2 className={classes.heading}>User Tour Milestones</h2>
              <Button
                onClick={(e) => {
                  handleClick(e);
                  userContext.setOpenTooltipNotification(false);
                  userContext.setOpenGlobalRiskTooltip(false);
                  const _userJourney = userContext.userJourneyInfo;
                  _userJourney.payload = {
                    title: "Start Tour",
                    steps: 1,
                  };
                  userContext.setUserJourneyInfo(_userJourney);
                  if (
                    window.location.pathname === "/kavida/tour/command-tower"
                  ) {
                    history.push("/kavida/tour/");
                    setTimeout(() => {
                      history.push("/kavida/tour/command-tower");
                    }, 10);
                  } else {
                    history.push("/kavida/tour/command-tower");
                  }
                  setProgress(0);
                  setSteps([
                    { status: "current", step: "1", name: "Control Tower" },
                    {
                      status: "incomplete",
                      step: "2",
                      name: "Threats & Alerts",
                    },
                    { status: "incomplete", step: "3", name: "Order Timeline" },
                    {
                      status: "incomplete",
                      step: "4",
                      name: "Communications Hub",
                    },
                    {
                      status: "incomplete",
                      step: "5",
                      name: "Add Shipping Information",
                    },
                    { status: "incomplete", step: "6", name: "Global Risks" },
                  ]);
                }}
                variant="contained"
                style={{
                  color: "white",
                  background: "#3B82F6",
                  marginRight: "3px",
                }}
              >
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </Button>
              <Button
                onClick={handleShow}
                variant="contained"
                style={{
                  color: "white",
                  background: "#3B82F6",
                  height: "26px",
                  fontSize: "12px",
                  fontFamily: "Inter",
                  textTransform: "capitalize",
                }}
              >
                {show ? (
                  <i class="fa fa-arrow-down" aria-hidden="true"></i>
                ) : (
                  <i class="fa fa-arrow-up" aria-hidden="true"></i>
                )}
              </Button>
            </div>
            {show && (
              <div className={classes.stepContainer}>
                <div className={classes.buttonsContainer}>
                  {steps.map((step, i) => (
                    <>
                      {step.status === "current" && (
                        <div
                          className={classes.buttonDiv}
                          style={{ background: "#DBEAFE" }}
                        >
                          <span className={classes.currentStepSpan}>
                            {step.step}
                          </span>
                          <p className={classes.buttonText}>{step.name}</p>
                        </div>
                      )}
                      {step.status === "incomplete" && (
                        <div
                          className={classes.buttonDiv}
                          style={{ background: "#F8FAFC" }}
                        >
                          <span className={classes.nextStepSpan}>
                            {step.step}
                          </span>
                          <p className={classes.buttonText}>{step.name}</p>
                        </div>
                      )}
                      {step.status === "completed" && (
                        <div
                          className={classes.buttonDiv}
                          style={{ background: "#D1FAE5" }}
                        >
                          <img
                            src={greenCheck}
                            className={classes.completedStepImg}
                          />
                          <p
                            className={classes.buttonText}
                            style={{ color: "#10B981" }}
                          >
                            {step.name}
                          </p>
                        </div>
                      )}
                    </>
                  ))}
                </div>
                <div
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    onClick={(e) => {
                      window.open(
                        "https://calendly.com/kavida-support/30min",
                        "_blank"
                      );
                    }}
                    variant="contained"
                    style={{
                      color: "white",
                      background: "#3B82F6",
                      width: "98%",
                      height: "40px",
                      padding: '12px'
                    }}
                  >
                    Contact Us
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Box>
      </Card>
    </div>
  );
};

export default ProgressBar;

const useStyles = makeStyles((theme) => ({
  progressBarContainer: {
    width: "300px",
    height: "auto",
    marginTop: "8px",
    right: 0,
    bottom: 0,
    zIndex: 1501,
    position: "fixed",
  },
  heading: {
    margin: "0",
    padding: "0",
    fontSize: "16px",
    fontWeight: "700",
    color: "#334155",
    fontFamily: "Inter",
  },
  buttonsContainer: {
    marginBottom: "10px",
  },
  buttonDiv: {
    display: "flex",
    marginTop: "8px",
    borderRadius: "100px",
    padding: "4px 16px 4px 4px",
  },
  buttonText: {
    margin: "0",
    fontFamily: "Inter",
    fontWeight: "700",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#7B8A9F",
    marginTop: "2px",
  },
  currentStepSpan: {
    width: "24px",
    textAlign: "center",
    background: "#3B82F6",
    borderRadius: "100px",
    color: "white",
    height: "24px",
    padding: "2px",
    marginRight: "6px",
    fontSize: "14px",
    fontWeight: "700",
  },
  nextStepSpan: {
    border: "1px solid #E2E8F0",
    background: "#FFFFFF",
    borderRadius: "100px",
    width: "24px",
    textAlign: "center",
    color: "#94A3B8",
    height: "24px",
    padding: "1px",
    marginRight: "6px",
    fontSize: "14px",
    fontWeight: "700",
  },
  completedStepImg: {
    width: "26px",
    height: "26px",
    marginRight: "6px",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  stepContainer: {
    marginTop: "30px",
  },
}));
